import { gql } from '@apollo/client'
import { BlockFragment } from 'app/features/shared/blocks'
import { BaseOfferBlock } from '../blocks.types'
import {
  LinkOnlyRedemptionBlockFragment,
  MultipleCodesRedemptionBlockFragment,
  Redemption,
  SingleCodeRedemptionBlockFragment,
} from 'app/features/offer/redemptions'

export const BrandOfferCollectionBlockFragment: BlockFragment = {
  name: 'brandFeaturedOffer',
  fragment: gql`
    fragment brandOfferCollection on BrandOfferCollection {
      id
      blockName
      blockType
      offers {
        id
        name
        tag
        description
        thumbnailImage {
          id
          url
          alt
        }
        featuredImage {
          id
          url
          alt
        }
        brand {
          id
          name
          slug
          logo {
            id
            url
            alt
          }
        }
        slug
        expiresAt
        offerLinkLabel
        offerLink
        offerLinkLabel
        redeemInList
        canRedeem
        redemptions {
          ${LinkOnlyRedemptionBlockFragment.partialFragment}
          ${MultipleCodesRedemptionBlockFragment.partialFragment}
          ${SingleCodeRedemptionBlockFragment.partialFragment}
        }
        isBookmarked
      }
      collection {
        id
        slug
      }
      limit
      linkToCollection
      title
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
  partialFragment: `
    ... on BrandOfferCollection {
      id
      blockName
      blockType
      offers {
        id
        name
        tag
        description
        thumbnailImage {
          id
          url
          alt
        }
        featuredImage {
          id
          url
          alt
        }
        brand {
          id
          name
          slug
          logo {
            id
            url
            alt
          }
        }
        slug
        expiresAt
        offerLinkLabel
        offerLink
        offerLinkLabel
        redeemInList
        canRedeem
        redemptions {
          ${LinkOnlyRedemptionBlockFragment.partialFragment}
          ${MultipleCodesRedemptionBlockFragment.partialFragment}
          ${SingleCodeRedemptionBlockFragment.partialFragment}
        }
        isBookmarked
      }
      collection {
        id
        slug
      }
      limit
      linkToCollection
      title
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
}

export const BrandOfferCollectionBlockType = 'brandOfferCollection'

export const canRenderBrandOfferCollectionBlock = (block: BrandOfferCollectionBlock): boolean => {
  if (!block.offers || block.offers.length === 0) {
    return false
  }

  return true
}

export interface BrandOfferCollectionBlock extends BaseOfferBlock {
  blockType: typeof BrandOfferCollectionBlockType

  offers: {
    id: string
    name: string
    thumbnailImage: {
      url: string
      alt: string
    }
    featuredImage: {
      url: string
      alt: string
    }
    slug: string
    description?: string
    tag?: string
    brand: {
      name: string
      slug: string
      logo: {
        url: string
        alt: string
      }
    }
    expiresAt: any
    isBookmarked: boolean
  }[]
  collection: {
    slug: string
  }

  limit: number

  linkToCollection: boolean
  title?: string

  redeemInList?: boolean
  canRedeem?: boolean
  offerLinkLabel?: string
  redemptions: Redemption[]
}
